import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useOpenItemPage } from '#features/work-items/item-navigation';
import { WorkItemList } from '#features/work-items/components/work-item-list';
import { workItemSearchSchema, type WorkItemSearch } from '#features/work-items/search-schema';

const ProjectRoute = () => {
  const { projectKey } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const openItemPage = useOpenItemPage();

  /**
   * `q` y los pasos del panel reemplazan la entrada del historial: sin esto, teclear una
   * palabra deja doce entradas y Atrás recorre item por item (diseño §11).
   */
  const onSearchChange = (patch: Partial<WorkItemSearch>): void => {
    const replace = 'q' in patch || 'item' in patch;
    void navigate({ search: (prev) => ({ ...prev, ...patch }), replace });
  };

  return (
    <WorkItemList
      key={projectKey}
      search={search}
      projectKey={projectKey}
      onSearchChange={onSearchChange}
      onExpand={openItemPage}
    />
  );
};

export const Route = createFileRoute('/_authed/$projectKey')({
  validateSearch: workItemSearchSchema,
  component: ProjectRoute,
});
